module.exports = __webpack_public_path__ + "static/media/Program22.3c0b3b2c.jpg";